import { defineStore } from "pinia"
import { fetchInvestmentData, getUserInvestments, fetchInterestType, fetchRiskCategory, fetchFee } from "@/api/investment"


export const useInvStore = defineStore("investment", {
  state: () => ({
    investments: [],
    userInvestment: [],
    interestType: [],
    riskCategory: [],
    fees: []
  }),

  actions: {
    async loadInvestments() {
      const res = await fetchInvestmentData()
      this.investments = res.data.data
    },
    async loadUserInvestments(id) {
      const res = await getUserInvestments(id)
      this.userInvestment = res.data.data
      // console.log('Loaded user investments:', this.userInvestment) // Debug log
    },
    async loadInterestType(){
      const res = await fetchInterestType()
      this.interestType = res.data.data
    },
    async loadRiskCategory(){
      const res = await fetchRiskCategory()
      this.riskCategory = res.data.data
    },
    async loadFees(){
      const res = await fetchFee()
      this.fees = res.data.data
    }
  }
})
